import { CurrencyEnum } from './currency-enum';

export class CompetitorOffer {
  modelName: string;
  categoryName: string;
  offerPrice: number;
  currency: CurrencyEnum;
  offerPriceInCurrency: number;
  isYourOffer?: boolean;
  valueY?: number;
  billingCurrency?: CurrencyEnum;
}
